import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { StarsAutocomplete, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';

import occupations from '@swf/generated/occupations.json';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import InfoPrompt from '../../../InfoPrompt/InfoPrompt';

import {
  TXTWCL_If_your_exact_job_title_is_not_ELL,
  TXTWCL_It_will_be_kept_confidential_a_ELL,
  TXTWCL_Occupation,
  TXTWCL_Please_enter_your_job_title_Xe_ELL_1,
  TXTWCL_Please_select_your_occupation__ELL,
  TXTWCL_WeXll_use_this_information_to__ELL,
  TXTWCL_WhatXs_your_occupationX,
  TXTWCL_Your_Occupation
} from './RMFOccupation.messages.json';
import { info, infoText, root } from './RMFOccupation.scss';
import EmployerFields from './components/EmployerFields/EmployerFields';

const RMFOccupation = () => {
  const rmfEmployerInfo = useFeature(FeatureFlag.RmfEmployerInfo);

  return (
    <Container
      page={RMFOccupation}
      headerProps={{
        title: <Translation {...TXTWCL_Occupation} />
      }}
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_occupationX} />}
      pageTopSubtitle={
        <>
          <Translation {...TXTWCL_WeXll_use_this_information_to__ELL} />{' '}
          {rmfEmployerInfo && <Translation {...TXTWCL_It_will_be_kept_confidential_a_ELL} />}
        </>
      }
    >
      <fieldset>
        <StarsAutocomplete
          id="profession"
          options={occupations}
          matchFrom="any"
          label={TXTWCL_Occupation}
          className={root}
          labelClassName={classNames(info)}
          labelContent={
            <InfoPrompt title={{ translation: TXTWCL_Your_Occupation }}>
              <p className={infoText}>
                <Translation {...TXTWCL_Please_enter_your_job_title_Xe_ELL_1} />{' '}
                <Translation {...TXTWCL_If_your_exact_job_title_is_not_ELL} />
              </p>
            </InfoPrompt>
          }
          maxLength={50}
          validators={[required(TXTWCL_Please_select_your_occupation__ELL)]}
          showValidationTick={false}
        />
        <EmployerFields />
      </fieldset>
      <CTAButton />
    </Container>
  );
};

RMFOccupation.displayName = 'RMFOccupation';

export default RMFOccupation;
